"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

// import PropTypes from '../../_util/vue-types';
// export default {
//   name: 'Column',
//   props: {
//     rowSpan: PropTypes.number,
//     colSpan: PropTypes.number,
//     title: PropTypes.any,
//     dataIndex: PropTypes.string,
//     width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
//     ellipsis: PropTypes.looseBool,
//     fixed: PropTypes.oneOf([true, 'left', 'right']),
//     align: PropTypes.oneOf(['left', 'center', 'right']),
//     customRender: PropTypes.func,
//     className: PropTypes.string,
//     // onCellClick: PropTypes.func,
//     customCell: PropTypes.func,
//     customHeaderCell: PropTypes.func,
//   },
// };
var Column = function Column() {
  return null;
};

var _default = Column;
exports.default = _default;